import { FC } from 'react';
import { getRouteApi } from '@tanstack/react-router';
import { KioskForms } from '@frontend/digital-forms-ui';

const routeApi = getRouteApi('/kiosk/forms_/$locationId');

export const KioskFormsPage: FC = () => {
  const { locationId } = routeApi.useParams();
  const { patientType = 'new' } = routeApi.useSearch();

  return <KioskForms locationId={locationId} patronType={patientType} />;
};
